export const GENDER_OPTIONS = [
  {
    value: "male",
    description: "Male",
  },
  {
    value: "female",
    description: "Female",
  },
];

export const DISABILITY_STATUS_OPTIONS = [
  {
    value: "yes",
    description: "Yes",
  },
  {
    value: "no",
    description: "No",
  },
];

export const EDUCATION_LEVEL_OPTIONS = [
  {
    value: "university",
    description: "University",
  },
  {
    value: "college",
    description: "College",
  },
  {
    value: "secondary",
    description: "Secondary",
  },
  {
    value: "primary",
    description: "Primary",
  },
];
